import { render, staticRenderFns } from "./ClaimCombinationTitle.vue?vue&type=template&id=c7682c76&scoped=true&"
import script from "./ClaimCombinationTitle.vue?vue&type=script&lang=js&"
export * from "./ClaimCombinationTitle.vue?vue&type=script&lang=js&"
import style0 from "./ClaimCombinationTitle.vue?vue&type=style&index=0&id=c7682c76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7682c76",
  null
  
)

export default component.exports